import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { State } from '../redux/redux.state';
import { AvailableFeaturesModel } from '../models/available.features';
import client from '../clients/client';

type FeaturesState = State<AvailableFeaturesModel[]>;

const initialState: FeaturesState = {
  data: [],
  status: 'idle',
};

export const getAvailableFeatures = createAsyncThunk<AvailableFeaturesModel[]>(
  'getAvailableFeatures',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.get('/available-features');
      return data;
    } catch (error: any) {
      const { status, data } = error.reponse;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

const availableFeaturesSlice = createSlice({
  initialState,
  name: 'availableFeatures',
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getAvailableFeatures.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        getAvailableFeatures.fulfilled,
        (state, action: PayloadAction<AvailableFeaturesModel[]>) => {
          state.status = 'successful';
          state.data = action.payload;
        }
      )
      .addCase(getAvailableFeatures.rejected, (state, action) => {
        state.status = 'error';
        state.errors = action.payload;
      }),
});

export default availableFeaturesSlice.reducer;
